import { round } from 'lodash';
import React from 'react';
import { IChartCardRightProps } from '.';
import { NumberChart } from '..';

const NumberRight: React.FC<IChartCardRightProps> = ({ helper }) => {
  return (
    <>
      <div className="flex justify-between mb3">
        <p className="f7 fw5 mt0 mb1">
          about {round(helper.averageByTimeScale)} per {helper.range.groupBy}
        </p>
        <p className="f7 fw5 mt0 mb1">{helper.measurementCount} entries</p>
      </div>
      <NumberChart range={helper.range} points={helper.sumSeries()} />
    </>
  );
};

export default NumberRight;
